import Api from '@/services/api';
import qs from 'querystring';

export default {
  get(object, id) {
    return Api().get("/documents/" + object + "/" + id);
  },
  get_single(object, id, params = false) {
    let str = "/document/" + id + "/" + object;
    if (params) {
      str += "?" + params;
    }
    return Api().get(str);
  },
  getAccusePreviewPDF(id) {
    return Api().get("/warrant/" + id + "/accuse/pdf");
  },
  getAssignationPreviewPDF(id) {
    return Api().get("/warrant/" + id + "/assignation/pdf");
  },
  update(data) {
    return Api().post(
      "/document/" + data.document_id + "/" + data.object,
      qs.stringify({ data: JSON.stringify(data.document) })
    );
  },
  add(object, id, file) {
    return Api().post("/documents/" + object + "/" + id, file);
  },
  suppress(object, document_id) {
    return Api().delete("/documents/" + object + "/" + document_id);
  },
  userinfo(path) {
    return Api().get(path);
  },
};